<template>
    <div class="field has-addons">
        <div class="control has-icons-left">
            <input v-model="result"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="number"
                   placeholder="Type Result (Price)">
            <span class="icon is-small is-left">
                <i class="fas fa-yen-sign"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
        <p class="control">
            <a class="button is-static">
                000 ¥
            </a>
        </p>
    </div>
</template>

<script>
    export default {
        computed: {
            result: {
                get: function () {
                    return this.$store.getters.getNewCarResult
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarResult', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorResult
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/ResultInput.vue